import { Table } from "@components/Table"
import { ScenarioRun } from "@custom-types/modelRun"
import ActionsCell from "@features/scenarioDesign/RunTable/ActionsCell"
import RunDetailsPanel from "@features/scenarioDesign/RunTable/RunDetailsPanel"
import { getRunTableColumns } from "@features/scenarioDesign/RunTable/helpers"
import { RunStatusDto } from "@store/services/runService"
import { MRT_RowSelectionState, MRT_Updater } from "material-react-table"
import { useState } from "react"
import { Box } from "@mui/material"
import { Typography } from "@mui/material"
import { CopyOnHover } from "@components/CopyOnHover"

export type RunTableProps = {
  runs: RunRow[]
  sessionStorageName: string
  onSelectChange: (selectedRowKeys: string[], deselectedRowKeys: string[]) => void
  runGroup: string
}

export type RunRow = ScenarioRun & {
  run_key: string
  is_creator_and_private: boolean
  model_key: string | undefined
  family: string
  base_graph_key: string
}

const RunTable = ({ sessionStorageName, runs, onSelectChange, runGroup }: RunTableProps) => {
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({})
  const rows = runs
  const columns = getRunTableColumns()

  const handleRowSelectionChange = (updater: MRT_Updater<MRT_RowSelectionState>) => {
    setRowSelection((prevState) => {
      const newState = updater instanceof Function ? updater(prevState) : updater

      const oldKeys = Object.keys(prevState)
      const newKeys = Object.keys(newState)
      const selected = newKeys.filter((key) => !oldKeys.includes(key))
      const deselected = oldKeys.filter((key) => !newKeys.includes(key))

      onSelectChange(selected, deselected)

      return newState
    })
  }

  return (
    <Table
      sessionStorageName={sessionStorageName}
      manualPagination
      data={rows}
      columns={columns}
      enableExpandAll={false}
      enableRowActions
      renderRowActions={ActionsCell}
      renderDetailPanel={({ row }) => <RunDetailsPanel runKey={row.original.run_key} />}
      enableRowSelection
      getRowId={(runRow) => runRow.run_key}
      onRowSelectionChange={handleRowSelectionChange}
      state={{ rowSelection }}
      positionToolbarAlertBanner="none" // hide "clear all" alert making table to move down
      muiSelectCheckboxProps={({ row }) => ({
        disabled: row.original.status !== RunStatusDto.DONE,
      })}
      muiSelectAllCheckboxProps={{
        disabled: rows.some((row) => row.status !== RunStatusDto.DONE),
      }}
      renderTopToolbarCustomActions={() => (
        <Box sx={{ display: "inline", padding: "8px" }}>
          Group ID:{" "}
          <CopyOnHover>
            <Typography sx={{ color: "#ccc" }}>{runGroup}</Typography>
          </CopyOnHover>
        </Box>
      )}
    />
  )
}

export default RunTable
